module.exports = __webpack_public_path__ + "img/warning.f434cef9.svg";